
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46uri_93FmSYeNXvC5Meta } from "/vercel/path0/pages/[...uri].vue?macro=true";
import { default as info_45screenxLjqFbeZrgMeta } from "/vercel/path0/pages/info-screen.vue?macro=true";
export default [
  {
    name: "uri",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "info-screen",
    path: "/info-screen",
    meta: info_45screenxLjqFbeZrgMeta || {},
    component: () => import("/vercel/path0/pages/info-screen.vue")
  }
]